import '../styles/stats.scss';

const revealFrame = (element) => {
    element.classList.remove('is-replaying');
    // Tvinga reflow så CSS-animationen startar om även om klasserna snabbt tas bort och läggs till
    void element.offsetWidth;
    element.classList.add('is-replaying', 'is-frame-drawn');
};

const applyCardOffsets = (items, progress) => {
    // Om elementen ligger på samma rad (t.ex. 3 kolumner i desktop)
    const isHorizontalRow = items.length > 1 && Math.abs(items[0].offsetTop - items[1].offsetTop) < 15;

    items.forEach((card, index) => {
        if (progress >= 1) {
            card.style.transform = '';

            return;
        }

        if (isHorizontalRow) {
            const col = index % 3;
            // col 0 når toppen vid progress = 0.70 (start: 60px)
            // col 1 når toppen vid progress = 0.85 (start: 110px)
            // col 2 når toppen vid progress = 1.00 (start: 160px)
            let endP = 1.0;
            let baseOffset = 160;

            if (col === 0) {
                endP = 0.70;
                baseOffset = 60;
            } else if (col === 1) {
                endP = 0.85;
                baseOffset = 110;
            }

            const colProgress = Math.min(1, Math.max(0, progress / endP));
            const remaining = 1 - colProgress;
            const offset = Math.round(baseOffset * remaining);

            card.style.transform = offset === 0 ? '' : `translate3d(0, ${offset}px, 0)`;
        } else {
            // Staplade vertikalt (mobil): beräkna per korts egen scrollposition
            const cardRect = card.getBoundingClientRect();
            const winH = window.innerHeight;
            const cardStart = winH;
            const cardEnd = winH * 0.45;

            if (cardRect.top >= cardStart) {
                card.style.transform = 'translate3d(0, 60px, 0)';
            } else if (cardRect.top <= cardEnd) {
                card.style.transform = '';
            } else {
                const cardP = (cardStart - cardRect.top) / (cardStart - cardEnd);
                const offset = Math.round(60 * (1 - Math.min(1, Math.max(0, cardP))));
                card.style.transform = offset === 0 ? '' : `translate3d(0, ${offset}px, 0)`;
            }
        }
    });
};

const revealOnScroll = (element) => {
    const rect = element.getBoundingClientRect();
    const revealThreshold = window.innerHeight * 0.7;
    const isInView = rect.top < revealThreshold && rect.bottom > 0;

    if (!isInView) {
        element.classList.remove('is-frame-drawn');
        element.classList.remove('is-replaying');
        return;
    }

    if (element.classList.contains('is-frame-drawn')) {
        return;
    }

    revealFrame(element);
};

const updateStatsParallax = () => {
    const windowHeight = window.innerHeight;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const containers = document.querySelectorAll('.f-stats-list__items');
    containers.forEach((container) => {
        const items = Array.from(container.querySelectorAll('.f-stats'));
        if (!items.length) {
            return;
        }

        if (prefersReduced) {
            items.forEach((item) => {
                item.style.transform = '';
            });

            return;
        }

        const rect = container.getBoundingClientRect();
        // Börja när sektionen når botten av viewporten
        const startPoint = windowHeight;
        // Slutposition när man i stort sett ser hela kortet / tills de kommit upp halvvägs i viewporten
        const endPoint = windowHeight * 0.45;

        if (rect.top >= startPoint) {
            applyCardOffsets(items, 0);
            items.forEach((item) => revealOnScroll(item));

            return;
        }

        if (rect.top <= endPoint) {
            applyCardOffsets(items, 1);
            items.forEach((item) => revealOnScroll(item));

            return;
        }

        const progress = Math.min(1, Math.max(0, (startPoint - rect.top) / (startPoint - endPoint)));
        applyCardOffsets(items, progress);
        items.forEach((item) => revealOnScroll(item));
    });

    // Fristående stats utanför en lista
    const standaloneStats = Array.from(document.querySelectorAll('.f-stats')).filter(
        (stat) => !stat.closest('.f-stats-list__items'),
    );

    standaloneStats.forEach((card) => {
        if (prefersReduced) {
            card.style.transform = '';

            return;
        }

        const cardRect = card.getBoundingClientRect();
        const cardStart = windowHeight;
        const cardEnd = windowHeight * 0.45;

        if (cardRect.top >= cardStart) {
            card.style.transform = 'translate3d(0, 80px, 0)';
            revealOnScroll(card);
        } else if (cardRect.top <= cardEnd) {
            card.style.transform = '';
            revealOnScroll(card);
        } else {
            const cardP = (cardStart - cardRect.top) / (cardStart - cardEnd);
            const offset = Math.round(80 * (1 - Math.min(1, Math.max(0, cardP))));
            card.style.transform = offset === 0 ? '' : `translate3d(0, ${offset}px, 0)`;
            revealOnScroll(card);
        }
    });
};

const initStatsAnimations = () => {
    const stats = document.querySelectorAll('.f-stats');

    if (!stats.length) {
        return;
    }

    stats.forEach((stat) => {
        let rotationDegrees = 0;
        const ctaBefore = stat.querySelector('.f-call-to-action__link');

        if (ctaBefore) {
            stat.addEventListener('click', (event) => {
                if (!event.target.closest('.f-call-to-action__link')) {
                    ctaBefore.click();
                }
            });
        }

        stat.addEventListener('pointerenter', () => {
            stat.classList.add('is-hovered');
            revealFrame(stat);

            if (ctaBefore) {
                rotationDegrees += 180;
                stat.style.setProperty('--cta-spin-deg', `${rotationDegrees}deg`);
            }
        });

        stat.addEventListener('pointerleave', () => {
            stat.classList.remove('is-hovered');
        });
    });

    let ticking = false;
    const onScrollOrResize = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                updateStatsParallax();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    // Initial beräkning vid laddning
    updateStatsParallax();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatsAnimations);
} else {
    initStatsAnimations();
}
